/**
 * Created by Darius on 2017.04.02.
 */
const defaultState = {
    tabIndex: 0
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'TAB_CHANGED':
            return {
                ...state,
                tabIndex: action.payload
            };
        case 'AUTHORIZATION_CHECKED':
            return {
                ...state,
                isAuthorized: true
            };
        case 'WP_WIN_SERVER_STATUS':
            return {
                ...state,
                windowsServerStatus: action.payload
            };
        case 'WP_LINUX_SERVER_STATUS':
            return {
                ...state,
                linuxServerStatus: action.payload
            };
        case 'WP_MESSAGES':
            return {
                ...state,
                messages: action.payload
            };
        case 'WP_QUEUES':
            return {
                ...state,
                time: new Date(),
                queues: action.payload
            };
        case 'QUEUES_PAUSE':
            return {
                ...state,
                pause: action.payload
            };
        case 'INITIAL_QUEUES':
            return {
                ...state,
                time: new Date(),
                queues: action.payload
            };
        case 'OPEN_QUEUE_CONFIRM_DIALOG':
            return {
                ...state,
                queue: action.payload.queue,
                action: action.payload.action,
                openDialog: action.payload.open,
                domain: action.payload.domain
            };
        case 'OPEN_QUEUE_EDIT_DIALOG':
            return {
                ...state,
                queue: action.payload.queue,
                openEdit: action.payload.open,
                domain: action.payload.domain
            };
        case 'CLOSE_QUEUE_DIALOG':
            return {
                ...state,
                openEdit: false,
                openDialog: false
            };
        case 'SUBMIT_QUEUE':
            return {
                ...state,
                openEdit: false
            };
        case 'QUEUE_ACTION_EXECUTED':
            return {
                ...state,
                saveStatus: action.payload.Status
            };
        case 'NOTIFY_USER':
            return {
                ...state,
                saveStatus: null,
            };
            break;
    }

    return state;
};